import API_URL from "../utils/config";
export const submitContactForm = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/contact-us-form`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to submit contact form");
    }

    return await response.json();
  } catch (error) {
    console.error("Error submitting contact us form:", error);
    throw error;
  }
};
export const submitGetStartedForm = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/get-started-form`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to submit get started form");
    }

    return await response.json();
  } catch (error) {
    console.error("Error submitting get started form:", error);
    throw error;
  }
};
export const submitReverseMortgageGuideForm = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/reverse-mortgage-guide-form`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to submit reverse mortgage guide form");
    }

    return await response.json();
  } catch (error) {
    console.error("Error submitting reverse mortgage guide form:", error);
    throw error;
  }
};
export const submitWantToRefinanceForm = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/want-to-refinance-form`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to submit refinance form");
    }

    return await response.json();
  } catch (error) {
    console.error("Error submitting refinance form:", error);
    throw error;
  }
};
export const submitLoanForm = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/request-loan-form`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to submit loan form");
    }

    return await response.json();
  } catch (error) {
    console.error("Error submitting loan form:", error);
    throw error;
  }
};
export const submitEmailSubscription = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/blog-subscribe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to submit email subscription form");
    }

    return await response.json();
  } catch (error) {
    console.error("Error submitting email subscription form:", error);
    throw error;
  }
};
export const submitSmsfLoanForm = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/smsf-loan-form`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to submit SMSF loan form");
    }

    return await response.json();
  } catch (error) {
    console.error("Error submitting SMSF loan form:", error);
    throw error;
  }
};
export const submitCommercialFinanceLoanForm = async (formData) => {
  try {
    console.log("API URL being used:", API_URL);
    console.log("Full endpoint URL:", `${API_URL}/commercial-finance-loan`);

    const response = await fetch(`${API_URL}/commercial-finance-loan`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      console.error("API Error Response:", errorData);
      throw new Error("Failed to submit commercial finance loan form");
    }

    return await response.json();
  } catch (error) {
    console.error("Error submitting commercial finance loan form:", error);
    throw error;
  }
};
export const submitReverseMortgageLoanForm = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/reverse-mortgage-form`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to submit commercial finance loan form");
    }

    return await response.json();
  } catch (error) {
    console.error("Error submitting commercial finance loan form:", error);
    throw error;
  }
};
export const submitLeaveAReplyForm = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/leave-a-reply`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to submit leave a reply form");
    }

    return await response.json();
  } catch (error) {
    console.error("Error submitting leave a reply form:", error);
    throw error;
  }
};
export const submitDownloadEbookForm = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/download-ebook`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to submit download ebook form");
    }

    return await response.json();
  } catch (error) {
    console.error("Error submitting download ebook form:", error);
    throw error;
  }
};
